import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { ReactComponent as DeleteIcon } from 'assets/icons/Delete.svg';
import React from 'react';
import { ReactFormGenerator } from 'react-form-builder2';
import 'react-form-builder2/dist/app.css';
import { formatDateInFormData, sanitizeItems } from 'utils/formDataHelper';



function FormPreview({
  formNames,
  formik,
  item,
  summary,
  body,
  handleDeleteClick,
  index,
  isExpanded,
  handleExpand,
  handleSelectedTemplateOptions
}) {

  const FormGenerator = () => {
    const filterFormData = sanitizeItems(item);
    return (
    <div style={{
      width: '500px',
    }}>
      
      <ReactFormGenerator
        data={formatDateInFormData(filterFormData)}
      />
    </div>
  );
  };


  const handleSelected = (event) => {
    event.stopPropagation();
    handleSelectedTemplateOptions(event, index)
  }

  return (
    <div
      className={
        isExpanded
          ? `class_template_accordion expanded_height`
          : "class_template_accordion"
      }
      key={index}
    >
      <Accordion expanded={isExpanded} onChange={handleExpand}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="align-items-center"
        >
           {index !== 0 && (
            <button onClick={(e) => {
              handleSelected(e)
            }} className='template-options-btn'>
              <MoreHorizIcon


              />
            </button>
          )}
          {
            <div className="d-flex align-items-center justify-content-between w-100 accordion_summary">
              {summary}
            </div>
          }
        </AccordionSummary>

        <AccordionDetails>
          <FormGenerator />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default FormPreview;
